export const Common = {
  emailDomainOptions: [
    'naver.com',
    'gmail.com',
    'hanmail.net',
    'nate.com',
    'daum.net',
    'kakao.com',
  ] as const,
  xlsxActionOnDuplicateNames: new Map([
    ['deny', '덮어쓰지 않고 알려줌'],
    ['update', '덮어쓰기 진행'],
  ]),
};
